import { ICreateTeam } from 'wisestep-api';

export const createTeamPayload: ICreateTeam = {
  id: '',
  name: '',
  ownerEmail: '',
  ownerId: '',
  type: 'provider',
  workspaceId: '',
  jobShareNotificationTo: '',
  jobClosedNotificationTo: '',
  jobInsightUpdateNotificationTo: '',
  candidateSubmissionNotificationTo: '',
  candidateStatusUpdateNotificationTo: '',
  disableJobShareNotificationTo: '',
  disableJobClosedNotificationTo: '',
  disableJobInsightUpdateNotificationTo: '',
  disableCandidateSubmissionNotificationTo: '',
  disableCandidateStatusUpdateNotificationTo: '',
};
